const ClientBranch = Object.freeze({
  BLUE: 'AZUL',
  GREEN: 'VERDE',
  PINK: 'ROSA',
  EXIT: 'EXIT'
})

module.exports = ClientBranch
